import { FormControl, FormLabel } from '@mui/joy';
import { QRCode } from 'react-qrcode-logo';
import { Avatar } from 'primereact/avatar';
import { usePDF } from 'react-to-pdf';
import { toPng } from 'html-to-image';
import { useEffect, useRef, useState } from 'react';
import { getFileBlobUrlS3Proxy } from '../service/s3Service';
import { Button } from 'primereact/button';

const dsfLogo = require('../assets/icon/DSF_Logo-Low-trimmed2.png');
const idCardTop = require('../assets/icon/EMPLOYEE_ID_Portrait_top.png');
const idCardBottom = require('../assets/icon/EMPLOYEE_ID_Portrait_bottom.png');
const idCardScanMe = require('../assets/icon/EMPLOYEE_ID -Scan.png');

interface inputPrams {
  image: string,
  logo: string,
  value: string,
  label: string,
  title: string
}

export default function EmployeeQrCode(params: inputPrams) {
  const [imageBlob, setImageBlob] = useState<Blob | null>(null);
  const [logoBlobURL, setLogoBlobURL] = useState<string | null>(null);
  const elementRef = useRef<HTMLImageElement>(null);
  const [layout, setLayout] = useState<'landscape' | 'portrait'>('landscape');

  const htmlToImageConvert = () => {
    console.log("elementRef == ", elementRef);
    if (elementRef?.current) {
      toPng(elementRef.current, { cacheBust: false })
        .then((dataUrl) => {
          console.log("dataUrl == ", dataUrl);
          const link = document.createElement("a");
          link.download = `${params.label}.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch((err) => {
          console.log('htmlToImageConvert error ', err);
        });
    }

  };

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(params.image);
        const blob = await response.blob();
        setImageBlob(blob);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, [params.image]);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await getFileBlobUrlS3Proxy(params.logo);
        setLogoBlobURL(response);
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    };

    fetchImage();
  }, [params.logo]);

  return (
    <FormControl>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', position: 'absolute', width: '100%' }}>
        <Button
          type="button"
          icon="pi pi-sync"
          label="Switch Layout"
          className="p-button-outlined"
          size="small"
          severity='warning'
          onClick={() => setLayout((v) => v === 'landscape' ? 'portrait' : 'landscape')}
        />
        <Button
          type="button"
          icon="pi pi-download"
          label="Download"
          className="p-button-outlined"
          size="small"
          onClick={htmlToImageConvert}
        />
      </div>
      <br /><br /><br />
      {
        layout === 'landscape' && (
          <div ref={elementRef} style={{
            width: 540,
            height: 340,
            border: '20px solid transparent',
            borderImage: 'linear-gradient(45deg, #6BC7D6, #000000, #4CB3E7) 1',
            borderImageSlice: 1
          }}>
            <div style={{ backgroundColor: 'white', position: 'relative', width: '100%', height: '100%' }}>
              {/* DSF Logo - Top Left */}
              <div style={{ position: 'absolute', left: 10, top: 5, width: 150, height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={dsfLogo} style={{ width: 140, height: 140, objectFit: 'contain' }} />
              </div>

              {/* Company Logo - Top Right */}
              <div style={{ position: 'absolute', right: 10, top: 5, width: 150, height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                  logoBlobURL && (
                    <img src={logoBlobURL} style={{ width: 140, height: 140, objectFit: 'contain' }} />
                  )
                }
              </div>

              {/* Center: Employee Image */}
              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: 160, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                  imageBlob && (
                    <img src={URL.createObjectURL(imageBlob)} style={{ width: 150, height: 150, borderRadius: '10rem', border: '3px solid #1c184c' }} />
                  )
                }
              </div>

              {/* QR Code - Bottom Left */}
              <div style={{ position: 'absolute', left: 10, bottom: 5, width: 150, height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <QRCode
                  style={{ height: 140, width: 140 }}
                  value={params.value}
                  qrStyle='dots'
                />
              </div>

              {/* Text - Bottom Right */}
              <div style={{ position: 'absolute', right: 10, bottom: 5, width: 150, height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                  style={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: 'large',
                    textAlign: 'center',
                    lineHeight: '1.2',
                    wordWrap: 'break-word',
                    overflow: 'hidden'
                  }}
                >
                  <div style={{ marginBottom: 10 }}>{params.label}</div>
                  <div style={{ fontSize: 'small' }}>{params.title}</div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        layout === 'portrait' && (
          <div ref={elementRef} style={{
            width: 340,
            height: 540,
            border: '20px solid transparent',
            borderImage: 'linear-gradient(45deg, #6BC7D6, #000000, #4CB3E7) 1',
            borderImageSlice: 1
          }}>
            <div style={{ backgroundColor: 'white', position: 'relative', width: '100%', height: '100%' }}>
              {/* Site Details at Top */}
              {/* DSF Logo - Top Left */}
              <div style={{ position: 'absolute', left: 10, top: 5, width: 140, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={dsfLogo} style={{ width: 130, height: 90, objectFit: 'contain' }} />
              </div>

              {/* Company Logo - Top Right */}
              <div style={{ position: 'absolute', right: 10, top: 5, width: 140, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                  logoBlobURL && (
                    <img src={logoBlobURL} style={{ width: 130, height: 90, objectFit: 'contain' }} />
                  )
                }
              </div>

              {/* Employee Image - Below logos */}
              <div style={{ position: 'absolute', left: '50%', top: 130, transform: 'translateX(-50%)', width: 160, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                  imageBlob && (
                    <img src={URL.createObjectURL(imageBlob)} style={{ width: 150, height: 150, borderRadius: '10rem', border: '3px solid #1c184c' }} />
                  )
                }
              </div>

              {/* Label and Title - Below image */}
              <div style={{ position: 'absolute', left: '50%', top: 310, transform: 'translateX(-50%)', width: '80%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div
                  style={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: 'large',
                    textAlign: 'center',
                    lineHeight: '1.2',
                    wordWrap: 'break-word',
                    overflow: 'hidden',
                    marginBottom: 5
                  }}
                >
                  {params.label}
                </div>
                <div
                  style={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: 'small',
                    textAlign: 'center',
                    lineHeight: '1.2',
                    wordWrap: 'break-word',
                    overflow: 'hidden'
                  }}
                >
                  {params.title}
                </div>
              </div>

              {/* QR Code - Bottom */}
              <div style={{ position: 'absolute', left: '50%', bottom: 15, transform: 'translateX(-50%)', width: 140, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <QRCode
                  style={{ height: 130, width: 130, marginTop: 10 }}
                  value={params.value}
                  qrStyle='dots'
                />
              </div>
            </div>
          </div>
        )
      }
    </FormControl>
  );
}